import React from 'react';
import PropTypes from 'prop-types';

const Globe02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12h20M12 2c2.5 2.8 3.9 6.3 3.9 10s-1.4 7.2-3.9 10c-2.5-2.8-3.9-6.3-3.9-10S9.5 4.8 12 2Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Globe02Icon.propTypes = {
  color: PropTypes.string,
};

export default Globe02Icon;
